import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MainLayout from '../../layout/MainLayout';

const useStyles = makeStyles(() => ({
    bg: {
        background: `url('../assets/bg.png')`,
        backgroundSize: 'cover',
        minHeight: '100vh',
        height: 'auto',
        width: '100vw',
        marginRight: '-20px !important',
        marginLeft: '-20px !important',
        display: 'flex',
        justifyContent: 'center',
    },
    title: {
        color: 'white',
        cursor: 'pointer',
        fontFamily: ['Poppins', 'regular'].join(','),
        fontSize: 24,
        textAlign: 'center',
    },
    link: {
        color: 'black',
        textDecorationLine: 'underline',
        cursor: 'pointer',
        marginTop: 100,
        fontFamily: ['Poppins', 'regular'].join(','),
        fontSize: 16,
    },
    margin: {
        margin: 'px 0px 40px 0px',
    },
    text: {
        color: '#383838',
        fontSize: '16px',
        fontFamily: ['Poppins', 'regular'].join(','),
    },
}));

export default () => {
    const classes = useStyles();
    const { t } = useTranslation(['about']);
    const history = useHistory();
    return (
        <MainLayout>
            <div className={classes.bg}>
                <Grid
                    container
                    justify="flex-start"
                    alignItems="center"
                    direction="column"
                    style={{ margin: 50 }}
                >
                    <Grid item lg={5} md={5} sm={12}>
                        <Grid item className={classes.margin}>
                            <Typography className={classes.title} variant="h4" color="initial">
                                {t('about:title')}
                            </Typography>
                        </Grid>
                        <br />
                        <Grid item>
                            <Typography className={classes.text} variant="h6">
                                {t('about:text')}
                            </Typography>
                        </Grid>

                        <Grid item>
                            <Typography
                                className={classes.link}
                                variant="h6"
                                color="initial"
                                onClick={() => {
                                    history.push('/privacy-policy');
                                }}
                            >
                                View Privacy Policy & Terms of Service
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </MainLayout>
    );
};
